import Constants from '../../model/AppConfiguration';
import selectors from '../../redux/selectors/Index.js';
import moment from 'moment';

export default {
  findRouteById,
  findTripByRoute,
  handlePassengersTabChange,
  handleCalendarTabChange,
  changePassengerNumber,
  handleClickOpen,
  handleClose,
  openCalendar,
  closeCalendar,
  selectDate,
  formatDateLongMonthWithDay,
  getArrivalDate,
  updateFlightsRoute,
  setUpReturnFlight,
};

function findRouteById (id, routes) {
  routes = routes || this.props.routes;
  return routes.find(route => route.id === `${id}`);
}

function findTripByRoute (routes, trips) {
  trips = trips || this.state.trips;
  let tripId = routes.length > 3 ? '3' : `${routes.length}`;
  return trips.find(trip => trip.id === tripId);
}

function handlePassengersTabChange (e, value) {
  this.setState({ selectedPassengersTab: value, passengersFormOpen: true });
}

function handleCalendarTabChange (e, value) {
  this.setState({ selectedCalendarTab: value, calendarOpen: true });
}

function changePassengerNumber (name, flightId, operator, sufix) {
  let { flights } = this.state;
  if (name && flightId) {
    if (sufix) {
      let adultsNumber = 0;
      let infantsNumber = 0;
      for (let i = 0; i < flights.length; i++) {
        let flight = flights[ i ];
        if (i !== 0) {
          flight.adults = adultsNumber;
          flight.infants = infantsNumber;
        } else {
          let shouldBeZero = operator === Constants.operator.minus && flights[ i ][ name ] <= 0;
          if (name === 'adults') {
            adultsNumber =
              operator === Constants.operator.minus ?
                shouldBeZero ? 0 : --flights[ i ][ name ] :
                ++flights[ i ][ name ];
            infantsNumber = flight.infants;
          } else {
            adultsNumber = flight.adults;
            infantsNumber =
              operator === Constants.operator.minus ?
                shouldBeZero ? 0 : --flights[ i ][ name ] :
                ++flights[ i ][ name ];
          }
        }
      }

      this.setState({ flights });
      return;
    }
    flights.find(flight => {
      if (flight.id === flightId) {
        if (operator === Constants.operator.minus) {
          if (flight[ name ] <= 0) {
            flight[ name ] = 0;
          } else {
            --flight[ name ];
          }

          this.setState({ flights });
          return;
        }
        ++flight[ name ];
        this.setState({ flights });
      }
    });
  }
}

function handleClickOpen (selectedTab) {
  this.setState({
    passengersFormOpen: true,
    calendarOpen: false,
    selectedPassengersTab: selectedTab,
  });
}

function handleClose () {
  this.setState({ passengersFormOpen: false, calendarOpen: false });
}

function openCalendar (selectedTab) {
  this.setState({
    calendarOpen: true,
    passengersFormOpen: false,
    selectedCalendarTab: selectedTab,
  });
}

function closeCalendar () {
  this.setState({ calendarOpen: false });
}

function selectDate (name, value, flightId, prefix, data) {
  if (!prefix) return;
  let { flights } = this.state;
  let flight = `${prefix}Flight`;
  let selectedFlight = prefix.toLowerCase() === 'departure' ? 0 : 1;

  flights[ selectedFlight ].id = data.id;
  flights[ selectedFlight ].date = value;

  this.setState({ flights, [ flight ]: data });
}

function formatDateLongMonthWithDay (date) {
  date = moment(date).locale('en');
  // .format('ddd MMM D, YYYY H:mm:ss')
  return moment(date)
    .format('MMM D YYYY')
    .replace(/\./g, '');
}

function getArrivalDate () {
  const selectedTrip = this.props.selectedTrip;
  const { departureDate, arrivalDate } = this.state;
  if (selectedTrip && selectedTrip.id === Constants.flights.roundTrip) {
    let arrivalMilis = new Date(moment(arrivalDate).format(Constants.DATE_FORMAT));
    arrivalMilis = arrivalMilis ? arrivalMilis.getTime() : null;
    let departureMilis = new Date(moment(departureDate).format(Constants.DATE_FORMAT));
    departureMilis = departureMilis ? departureMilis.getTime() : null;

    return arrivalMilis >= departureMilis ? arrivalDate : moment(departureDate).add(7, 'days');
  }
  return '';
}

function updateFlightsRoute (newRoute, oldRoute) {
  if (!newRoute.id || !oldRoute.id) {
    return;
  }

  let { flights } = this.state;

  for (let i = 0; i < flights.length; i++) {
    if (flights[ i ].routeId === oldRoute.id) {
      flights[ i ].routeId = newRoute.id;
    } else {
      flights[ i ].routeId = oldRoute.id;
    }
  }

  this.setState({ flights });
}

function setUpReturnFlight (allFlights) {
  let { flights } = this.props;
  const { selectedRoute } = this.state;
  let currentFlightRouteId = selectedRoute && selectedRoute.id ? selectedRoute.id : '';

  if (!currentFlightRouteId || (flights && flights.length > 1)) return;

  let newFlightRouteId = currentFlightRouteId === '1' ? '2' : '1';
  let secondRouteFlights = selectors.allFlights.getAllFlightsByRouteId(
    allFlights,
    newFlightRouteId
  );
  let firstReturnFlight = { id: '', date: '' };
  if (secondRouteFlights && secondRouteFlights.flights && secondRouteFlights.flights.length) {
    firstReturnFlight = secondRouteFlights.flights[ 0 ];
  }
  let newFlight = {
    routeId: newFlightRouteId,
    id: firstReturnFlight.id,
    date: firstReturnFlight.date,
    adults: flights[ 0 ].adults,
    infants: flights[ 0 ].infants,
  };

  flights.push(newFlight);
  this.props.actions.updateFlights(flights);
}



// WEBPACK FOOTER //
// ./src/containers/flights/FlightsScreenController.js